<image [src]="getImageSrc()"></image>
<h3>{{ name }}</h3>
<p>{{ short_description }}</p>
